import React, { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { BiChevronsRight, BiChevronsDown } from "react-icons/bi";

import RespNpsModal from "../Modals/RespNpsModal";
import { useRespNpsModal } from "../Modals/RespNpsModal/useModal";

import DealDetailModal from "../Modals/DealDetailModal";
import { useDealDetailModal } from '../../components/Modals/DealDetailModal/useModal'

import {
    Container,
    HeaderContainer,
    Title,
    IconButton,
    DealDetailSpec,
    DealDetailTextBox,
    ButtonsBox
} from './styles';
import DeclineAnswer from "../Dialogs/DeclineAnswer";
import axios from "axios";
import { bitrixUrl } from "../../api/base";
import toast from 'react-hot-toast';
import ItemP from "./ItemP";

interface IItemProps {
    id: string;
    descricao: string;
    dataInicio: string;
    dataFechamento: string;
    fase: string;
    resolucao: string;
    nps: string;
    status: string;
    categoria: string;
    classificacao: string;
    tempoDesenvolvimento: string;
    userName: string;
    statusFaseV2: string;
    pipelineV2: string;
    idChamadoAnterior: string;
    faseV2: string;
    linkFormulario: string;
    nomeEmailUsuario: string;
    departUserModeloPermissoes: string;
    nomeRoleta: string;
    desenvolvedores: string;
    paraQuemTransferir: string;
    idCardProblema: string;
    retornoPendencia: string;
    clienteDesejaFinalizar: string;
    porqueClienteEstaFinalizandoChamado: string;
    dataEntradaPendenteCliente: string;
    idResponsavel: string;
}

function isFilled(field: string): boolean {
    return (!field) ? false : true;
}

const Item: React.FC<IItemProps> = ({
    id,
    descricao,
    dataInicio,
    dataFechamento,
    fase,
    resolucao,
    nps,
    status,
    categoria,
    classificacao,
    tempoDesenvolvimento,
    userName,
    statusFaseV2,
    pipelineV2,
    idChamadoAnterior,
    faseV2,
    linkFormulario,
    nomeEmailUsuario,
    departUserModeloPermissoes,
    nomeRoleta,
    desenvolvedores,
    paraQuemTransferir,
    idCardProblema,
    retornoPendencia,
    clienteDesejaFinalizar,
    porqueClienteEstaFinalizandoChamado,
    dataEntradaPendenteCliente,
    idResponsavel
}) => {

    const [color, setColor] = useState("");
    const [cardStatus, setCardStatus] = useState<boolean>(true);
    const [cardNpsResp, setcardNpsResp] = useState<boolean>(false);

    const handleSetCardStatus = () => {
        setCardStatus(!cardStatus);
    }

    const { isShownRespNpsModal, toggleRespNpsModal } = useRespNpsModal();

    const { isShownDealDetailModal, toggleDealDetailModal } = useDealDetailModal();

    useEffect(() => {
        if (nps === 'Não respondido' && status === "S") {
            setcardNpsResp(!cardNpsResp);
        }

        if (status === "P") {
            setColor("#5573b7");
        } else if (status === "S") {
            setColor("#7bd500");
        } else {
            setColor("#ff5752");
        }
    }, []);

    useEffect(() => {

        if (nps === 'Não respondido' && status === "S" && !cardStatus) {
            // alert('Este Chamado não teve sua avaliação respondida!\nFavor realizar!');
            toast.error('Este Chamado não teve sua avaliação respondida!\nFavor realizar!')
        }

    }, [cardStatus])

    var titleText = id;
    if (isFilled(categoria)) {
        titleText += ' - ' + categoria;
    }

    function handleDeclineAnswer(content: string) {
        let text = "Chamado recusado por " + userName + "\n\nMotivo: " + content;

        let data = {
            "id": id,
            "fields": {
                "UF_CRM_1622818975": text,
                "UF_CRM_1622639517": "76",
                "STAGE_ID": "C14:1"
            }
        }
        axios.post(bitrixUrl + '/crm.deal.update', data)
            .then(response =>
                toast.success('Mensagem encaminhada, em breve entraremos em contato.')
            )
            .catch(e =>
                console.log(e)
            )
    }

    return (
        <Container>
            <HeaderContainer color={color}>
                <Title>
                    {titleText}
                </Title>
                <IconButton onClick={handleSetCardStatus}>
                    <IconContext.Provider value={{ color: 'black', size: '50px' }}>
                        {cardStatus ? <BiChevronsRight /> : <BiChevronsDown />}
                    </IconContext.Provider>
                </IconButton>
            </HeaderContainer>
            {cardStatus ? <> </> : <DealDetailSpec>
                <DealDetailTextBox>
                    {isFilled(id) ? <ItemP title="Ticket ID:" content={id} /> : <></>}
                    {isFilled(fase) ? <ItemP title="Fase:" content={fase} /> : <></>}
                    {isFilled(dataInicio) ? <ItemP title="Data de abertura:" content={dataInicio} /> : <></>}
                    {isFilled(dataFechamento) ? <ItemP title="Data de fechamento:" content={dataFechamento} /> : <></>}
                    {/* { isFilled(statusFaseV2) ? <ItemP title="Status da fase:" content={statusFaseV2} /> : <></>} */}
                    {isFilled(pipelineV2) ? <ItemP title="Pipeline:" content={pipelineV2} /> : <></>}
                    {isFilled(idChamadoAnterior) ? <ItemP title="ID do chamado anterior:" content={idChamadoAnterior} /> : <></>}
                    {/* { linkFormulario ? <ItemP title="Link do formulário:" content={linkFormulario} /> : <></> } */}
                    {isFilled(nomeEmailUsuario) ? <ItemP title="Nome / e-mail do usuário:" content={nomeEmailUsuario} /> : <></>}
                    {isFilled(departUserModeloPermissoes) ? <ItemP title="Departamento / Usuário modelo para as permissões:" content={departUserModeloPermissoes} /> : <></>}
                    {isFilled(nomeRoleta) ? <ItemP title="Nome da roleta:" content={nomeRoleta} /> : <></>}
                    {/* { desenvolvedores ? <ItemP title="Desenvolvedor(es):" content={desenvolvedores} /> : <></> } */}
                    {isFilled(paraQuemTransferir) ? <ItemP title="Para quem transferir os cards que estão sob responsabilidade:" content={paraQuemTransferir} /> : <></>}
                    {isFilled(idCardProblema) ? <ItemP title="ID de um card onde foi observado o problema:" content={idCardProblema} /> : <></>}
                    {/* {isFilled(retornoPendencia) ? <ItemP title="Retorno da pendência:" content={retornoPendencia} /> : <></>} */}
                    {isFilled(clienteDesejaFinalizar) ? <ItemP title="Cliente deseja finalizar o chamado?" content={clienteDesejaFinalizar} /> : <></>}
                    {isFilled(porqueClienteEstaFinalizandoChamado) ? <ItemP title="Por que o cliente está finalizando o chamado?:" content={porqueClienteEstaFinalizandoChamado} /> : <></>}
                    {isFilled(dataEntradaPendenteCliente) ? <ItemP title="Data de entrada na fase pendente cliente:" content={dataEntradaPendenteCliente} /> : <></>}
                    {/* { isFilled(idResponsavel) ? <ItemP title="ID Responsável:" content={idResponsavel} /> : <></>} */}

                    <ButtonsBox>
                        {cardNpsResp ? <button onClick={toggleRespNpsModal}>Responder NPS</button> : <></>}
                        <RespNpsModal
                            hideModal={toggleRespNpsModal}
                            isModalVisible={isShownRespNpsModal}
                            codDeal={id}
                        />
                        <button onClick={toggleDealDetailModal}>Detalhes</button>
                        {isShownDealDetailModal ? <DealDetailModal
                            hideModal={toggleDealDetailModal}
                            isModalVisible={isShownDealDetailModal}
                            codDeal={id}
                        /> : <></>}

                        {cardNpsResp ? <DeclineAnswer onDeclineAnswer={handleDeclineAnswer} /> : <></>}
                    </ButtonsBox>
                </DealDetailTextBox>
                <DealDetailTextBox>
                    <h1>Descrição</h1>
                    <p>{descricao}</p>
                    <br />
                    <hr />
                    <h4 hidden={!isFilled(retornoPendencia)}>Retorno da pendência</h4>
                    <p hidden={!isFilled(retornoPendencia)}>{retornoPendencia}</p>
                </DealDetailTextBox>
                <DealDetailTextBox>
                    <h1>Resolução</h1>
                    <p>{resolucao}</p>
                    <br />
                    <hr />
                    <h5>Tempo de desenvolvimento: </h5><span>{tempoDesenvolvimento} (min)</span>
                    <h5>Classificação: </h5><span>{classificacao}</span>
                </DealDetailTextBox>
            </DealDetailSpec>}
        </Container>
    )
}

export default Item;